import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';
import { Button } from '../../components';
import useDocumentHead from '../../hooks/useDocumentHead';
import { useLang } from '../../i18n';
import './NotFoundPage.scss';

export default function NotFoundPage() {
  const { t } = useLang();
  useDocumentHead({
    title: `404 — ${t('brand.name')}`,
    description: t('notfound.sub'),
  });
  return (
    <div className="notfound">
      <div className="container notfound__inner">
        <div className="notfound__icon" aria-hidden="true">
          <MapPin size={80} />
        </div>
        <div className="notfound__code">404</div>
        <h1 className="notfound__title">{t('notfound.title')}</h1>
        <p className="notfound__sub">{t('notfound.sub')}</p>
        <Link to="/" className="notfound__link">
          <Button variant="primary" size="lg">{t('notfound.home')}</Button>
        </Link>
      </div>
    </div>
  );
}
